const React = require("react");
const T = require("prop-types");
const Paper = require("material-ui/Paper").default;
const RaisedButton = require("material-ui/RaisedButton").default;

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "2rem 0"
};

module.exports = class GiftCredits extends React.Component {
    static propTypes = {
        isUploading: T.bool.isRequired,

        uploadGiftCreditsCSV: T.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            formError: ""
        };

        this.fileRef = React.createRef();
        this.onUpload = this.onUpload.bind(this);
        this.uploadForm = this.uploadForm.bind(this);
    }

    onUpload(err) {
        if (!err) {
            // Clear the file selection on upload success so it doesn't accidentally get
            // uploaded twice
            this.fileRef.current.value = null;
        }

        this.setState({ formError: err });
    }

    uploadForm(e) {
        e.preventDefault();
        this.props.uploadGiftCreditsCSV(this.fileRef.current, this.onUpload);
    }

    render() {
        return (
            <div>
                <h2>Gift Credits</h2>

                <p>
                    Upload a .csv file to gift credits to users. If an email has
                    not yet been registered a new account will be created.
                </p>
                <p>
                    An example .csv has been provided below. The fields in the
                    example are all required, and any additional fields will be
                    ignored.
                </p>

                <pre>
                    <b>first_name,last_name,email,credits</b>
                    <br />
                    John,Smith,johnsmith@example.com,1
                    <br />
                    Marie,Betty,mariebetty@example.com,1
                </pre>

                <Paper style={internals.paperStyle}>
                    <form onSubmit={this.uploadForm}>
                        <p style={{ color: "red" }}>{this.state.formError}</p>

                        <div className="form-group">
                            <input
                                type="file"
                                accept="text/csv"
                                ref={this.fileRef}
                                required
                            />
                        </div>

                        <RaisedButton
                            primary
                            label="Upload"
                            labelStyle={{
                                textTransform: "inherit"
                            }}
                            type="submit"
                            disabled={this.props.isUploading}
                        />
                    </form>
                </Paper>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/admin-gift-credits/components/GiftCredits.js